import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation from '_nav';
// routes config
import routes, { DashboardRoute } from 'routes';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';

import DataGrid from 'components/datagrid/DataGrid';
import PowerGrid from 'components/powergrid/PowerGrid';
import EditableForm from '../editableform/EditableForm';

const STORAGE_LAST_LOCATION_KEY = 'bifrost-frontend-last-location';

class DefaultLayout extends Component {

  constructor(props) {
    super(props);

    this.state = {
      filter: []
    };
  }

  componentDidMount() {
    this.unlistenHistory = this.props.history.listen((location, action) => {

      let lastLocation = localStorage.getItem(STORAGE_LAST_LOCATION_KEY);

      if (!lastLocation
        || (action === 'PUSH' && !location.pathname.startsWith(lastLocation))
        || (action === 'POP' && !lastLocation.startsWith(location.pathname))
      ) {
        DataGrid.clearStorageCache();
        PowerGrid.clearStorageCache();
        EditableForm.clearStorageCache();
      }

      localStorage.setItem(STORAGE_LAST_LOCATION_KEY, location.pathname);
    });
  }

  componentWillUnmount() {
    this.unlistenHistory && this.unlistenHistory();
  }

  onFilterChange = (filterValue) => {
    this.setState({
      filter: filterValue
    });
  }



  render() {
    return (
      <div className="app">
        <AppHeader fixed>
          <DefaultHeader keycloak={this.props.keycloak} onFilterChange={this.onFilterChange} />
        </AppHeader>
        <div className="app-body app-body-overflow">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav navConfig={navigation} {...this.props} />
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            <AppBreadcrumb appRoutes={routes} />
            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} component={props => (
                    <route.component {...props} keycloak={this.props.keycloak} filter={this.state.filter} />
                  )} />)
                    : (null);
                },
                )}
                <Redirect from="/" to={DashboardRoute.path} />
              </Switch>
            </Container>
          </main>
        </div>
        <AppFooter>
          <DefaultFooter />
        </AppFooter>
      </div>
    );
  }
}

export default DefaultLayout;
